<template>
  <div v-loading="loading" class="out_box">
    <div class="detail_t_box">
      <div>
        <div class="detail_t">
          <div>
            <div class="detail_label">批次</div>
            <div class="detail_value">{{ detailData.batch_number }}</div>
          </div>
          <div style="margin-left: 16px">
            <div class="detail_label">状态</div>
            <el-tag type="info" effect="dark" v-if="detailData.status == 0">
              未开始
            </el-tag>
            <el-tag type="warning" effect="dark" v-if="detailData.status == 1">
              进行中
            </el-tag>
            <el-tag type="success" effect="dark" v-if="detailData.status == 2">
              完成
            </el-tag>
            <el-tag type="danger" effect="dark" v-if="detailData.status == 3">
              已取消
            </el-tag>
          </div>
        </div>
        <div class="detail_t2">
          <div>创建时间：{{ detailData.create_time }}</div>
          <div style="margin-left: 24px">数量：{{ detailData.num }}</div>
          <div style="margin-left: 24px" class="t2_status">
            成功：{{ successNum }}
          </div>
        </div>
      </div>
    </div>
    <div class="btn_box" :class="{is_fixed: isFixed}" :style="isFixed ? `width: ${btnBoxWidth}px` : ''">
      <div>
        <el-button class="btn_download" style="width: 42px;padding: 0;" @click="$router.back()"><i class="el-icon-arrow-left"></i></el-button>
        <el-button
          class="btn_download"
          @click="downloadAll(detailData.batch_number, 'all')"
          >下载全部</el-button
        >
        <el-button
          class="btn_download"
          @click="downloadAll(detailData.batch_number, 'isSelect')"
          v-if="showOperate"
          >下载选中</el-button
        >
        <el-dropdown @command="selectedAllSingle">
          <el-button class="el-dropdown-link btn_plain">快速选中</el-button>
          <el-dropdown-menu slot="dropdown" v-if="selectAllLen">
            <el-dropdown-item command="all">选择全部</el-dropdown-item>
            <el-dropdown-item v-for="(item, index) in selectAllLen" :command="index">选择第{{item}}张</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button class="btn_plain" @click="exportToExcel">导出数据</el-button>
        <el-button class="btn_plain" @click="tempExport">按模版导出 </el-button>
        <ImageOperate v-if="showOperate" ref="ImageOperateRef" :imageList="detailData.materialGroups" />
      </div>
      <div>
        <el-button
          class="btn_right"
          @click="templateTaskDetail($route.query.id)"
          >刷新</el-button
        >
      </div>
    </div>
    <div class="placecss" v-show="isFixed"></div>
    <div
      class="line_box"
      v-for="(materialG, index) in detailData.materialGroups"
    >
      <div class="line_l">
        <div class="line_t">
          <div>原图</div>
          <div
            class="line_t_download"
            @click="downSucais(materialG.materials, '素材图组' + (index + 1))"
          >
            下载 <img src="@/assets/images/download.png" />
          </div>
        </div>
        <div class="line_l_main">
            <el-image :src="materialG.materials[0].url" fit="contain" :preview-src-list="materialG.materials.map(item => item.url)"></el-image>
          </div>
        <div class="line_l_thumb">
          <div class="line_thumb" v-for="file in materialG.materials">
            <img :src="file.url" />
          </div>
        </div>
      </div>
      <i class="el-icon-d-arrow-right"></i>
      <div class="line_r">
        <div class="line_t">
          <div>
            <el-checkbox
              v-model="materialG.checked"
              :indeterminate="materialG.indeterminate"
              @change="materialGselected($event, materialG)"
              style="margin-right: 8px"
              :disabled="!materialG.hasimg"
            ></el-checkbox
            >生成图
          </div>
          <div
            class="line_t_download"
            @click="
              downImgs(
                materialG.image_urls,
                detailData.batch_number + '组' + (index + 1)
              )
            "
          >
            下载 <img src="@/assets/images/download.png" />
          </div>
        </div>
        <div class="line_img">
          <div class="line_img_item" v-for="(item, i) in materialG.image_urls">
            <div style="position: relative;">
              <el-checkbox
                :disabled="!item.result_image_url"
                v-model="item.checked"
                @change="checkedSingleChange($event, materialG)"
              ></el-checkbox>
              <div class="line_img_mask" v-show="item.result_image_url">
                <div class="line_img_prev" @click="checkimgs(index, i)">
                  <i class="el-icon-view"></i>
                </div>
                <div
                  class="line_img_btn"
                  @click="downloadSingleImage(item.result_image_url, 'image' + item.id)"
                >
                  下载
                </div>
              </div>
              <el-image
                class="line_img_main"
                :src="
                  item.result_image_url
                    ? item.result_image_url
                    : require('@/assets/images/loading.gif')
                "
                :preview-src-list="[
                  item.result_image_url
                    ? item.result_image_url
                    : require('@/assets/images/loading.gif'),
                ]"
                fit="contain"
                :ref="`productimg_urls${index}${i}`"
              />
              
            </div>
            <div class="line_title" v-if="item.image_title" :title="item.image_title">{{ item.image_title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_bottom" :style="{width: `${btnBoxWidth}px`}" :class="{imageless: detailData.materialGroups.length < 2}" v-if="showOperate">
      <div class="selected_num">已选择 {{showOperate}} 张
      </div>
    </div>
    <ExportAccordTemp ref="ExportAccordTempRef" pageType="setPicture" :dataIds="group_ids" />
   
  </div>
</template>
<script>
import { templateTaskDetail, templateTaskExportExcel } from "@/api/templateTask";
import JSZip from "jszip";
import FileSaver from "file-saver";
import { downloadImages, downloadSingleImage, downloadToZip } from '@/utils/download'
import FixedTop from '@/views/figures/FixedTop'

import ExportAccordTemp from "@/components/ExportAccordTemp.vue";
import ImageOperate from "@/components/ImageOperate.vue";
export default {
  name: "SetPictureDetail",
  components: { ExportAccordTemp, ImageOperate },
  mixins: [ FixedTop ],
  data() {
    return {
      detailData: {},
      loading: false,

      selectAllLen: 0,
      group_ids: [],
    };
  },
  created() {
    if (this.$route.query && this.$route.query.id) {
      this.templateTaskDetail(this.$route.query.id);
    }
  },
  computed: {
    successNum: function () {
      let success_num = 0;
      if (this.detailData && this.detailData.materialGroups) {
        this.detailData.materialGroups.forEach((materialG) => {
          let is_success = true;
          materialG.image_urls.forEach((img) => {
            if (img.result_image_url == "" || img.result_image_url == null) {
              is_success = false;
            }
          });
          if (is_success) {
            success_num++;
          }
        });
      }
      return success_num;
    },
    showOperate() {
      let selectLen = 0;
      this.detailData.materialGroups.forEach(item => {
        let imgslen = item.image_urls.filter(iten => iten.checked)
        selectLen += imgslen.length
      })
      // let haschecked = this.detailData.materialGroups?.find(item => item.image_urls.some(iten => iten.checked))
      return selectLen
    }
  },
  methods: {
    downloadSingleImage,
    downSucais(sucais, name) {
      let dataList = [];
      sucais.forEach((sucai,index) => {
        let suffix = sucai.url.substring(sucai.url.lastIndexOf("."))
        dataList.push({
          name: sucai.name || `${sucai.task_id}-${index+1}${suffix}`,
          url: sucai.url,
        });
      });
      if (dataList.length > 0) {
        downloadImages(dataList, name);
      } else {
        this.$message.warning("所选中暂无成品图");
      }
    },
    downImgs(images, name) {
      let dataList = [];
      images.forEach((img) => {
        if (img.checked && img.result_image_url != "") {
          dataList.push({
            name: "image" + img.id + ".png",
            url: img.result_image_url,
          });
        }
      });
      if (dataList.length > 0) {
        downloadImages(dataList, name);
      } else {
        this.$message.warning("所选中暂无成品图");
      }
    },
    downloadAll(name, type) {
      let dataList = [];
      this.detailData.materialGroups.forEach((materialG) => {
        materialG.image_urls.forEach((img) => {
          if (img.result_image_url != "" && ((type == 'isSelect' && img.checked) || type == 'all')) {
            dataList.push({
              name: "image" + img.id + ".png",
              url: img.result_image_url,
            });
          }
        });
      });
      if (dataList.length > 0) {
        downloadImages(dataList, name);
      } else {
        this.$message.warning("暂无成品图");
      }
    },
    selectedAll() {
      this.detailData.materialGroups.forEach((materialG) => {
        materialG.image_urls.forEach((img) => {
          if(img.result_image_url && !img.checked) {
            materialG.checkedLength++
            this.$set(img, "checked", true);
          }
        });
        let slen = materialG.hasimg == materialG.image_urls.length ? materialG.image_urls.length : materialG.hasimg
        this.$set(materialG, 'checked', materialG.checkedLength == slen)
        this.$set(materialG, 'indeterminate', materialG.checkedLength > 0 && materialG.checkedLength < slen)
      });
    },
    exportToExcel() {
      let ids = []
      this.detailData.materialGroups.forEach(materialG => {
        if(materialG.checked) ids.push(materialG.id)
      })
      if(ids.length) {
        templateTaskExportExcel({group_ids: ids}).then(res => {
          this.$message.success("导出成功");
          FileSaver.saveAs(res.data.url, this.detailData.batch_number + '.xlsx');
        })
      }else {
        this.$message.warning("请选择要导出的成品图");
      }
    },
    tempExport() {
      this.group_ids = []
      this.detailData.materialGroups.forEach(materialG => {
        let position = []
        materialG.image_urls.forEach((iten, indey) => {
          if(iten.checked) {
            position.push(indey)
          }
        })
        if(position.length) {
          this.group_ids.push({id: materialG.id, position: position})
        }
      })
      if(this.group_ids.length) {
        this.$refs.ExportAccordTempRef.dialogTempVisible = true
        
      }else {
        this.$message.warning("请选择要按模板导出的成品图");
      }
    },
    selectedAllSingle(command) {
      this.detailData.materialGroups.forEach(item => {
        if(command == 'all') {
          item.image_urls.forEach((iten, indey) => {
            iten.checked = true
          })
          let slen = item.hasimg == item.image_urls.length ? item.image_urls.length : item.hasimg
          this.$set(item, 'checkedLength', slen);
          this.$set(item, 'checked', true);
          this.$set(item, 'indeterminate', false);
        } else {
          if(item.image_urls[command].result_image_url) {
            item.image_urls.forEach((iten, indey) => {
                iten.checked = indey == command
              })
            item.checkedLength = 1
            let slen = item.hasimg == item.image_urls.length ? item.image_urls.length : item.hasimg
            this.$set(item, 'checked', item.checkedLength == slen)
            this.$set(item, 'indeterminate', item.checkedLength > 0 && item.checkedLength < slen)
            this.$set(item.image_urls[command], "checked", true);
          }
        }
      });
    },
    checkedSingleChange(val, materialG) {
      val ? materialG.checkedLength++ : materialG.checkedLength--
      let slen = materialG.hasimg == materialG.image_urls.length ? materialG.image_urls.length : materialG.hasimg
      this.$set(materialG, 'checked', materialG.checkedLength == slen)
      this.$set(materialG, 'indeterminate', materialG.checkedLength > 0 && materialG.checkedLength < slen)
    },
    checkimgs(index, i) {
      const refName = `productimg_urls${index}${i}`;
      setTimeout(() => {
        this.$refs[refName][0].$el.children[0].click();
      }, 7);
    },
    materialGselected(v, materialG) {
      materialG.image_urls.forEach((img) => {
        if(img.result_image_url) {
          if(img.checked != v) {
            v ? materialG.checkedLength++ : materialG.checkedLength--
          }
          this.$set(img, "checked", v);
        }
      });
      let slen = materialG.hasimg == materialG.image_urls.length ? materialG.image_urls.length : materialG.hasimg
      // this.$set(materialG, 'checked', materialG.checkedLength == slen)
      this.$set(materialG, 'indeterminate', materialG.checkedLength > 0 && materialG.checkedLength < slen)
    },
    templateTaskDetail(id) {
      this.loading = true;
      templateTaskDetail(id)
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.detailData = res.data;
            this.detailData.materialGroups.forEach((materialG) => {
              let images = this.detailData.images.filter(
                (image) => image.group_id == materialG.id
              );
              let hasimg = 0
              images.forEach((img) => {
                if(img.result_image_url) {
                  hasimg++
                }
                this.$set(img, "checked", false);
              });
              this.selectAllLen = images.length
              this.$set(materialG, "hasimg", hasimg);
              this.$set(materialG, "indeterminate", false);
              this.$set(materialG, "checkedLength", 0);
              this.$set(materialG, "checked", false);
              this.$set(materialG, "image_urls", images);
            });
          }
          this.messageBox(res);
        })
        .catch((error) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.out_box {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 24px 16px;
  .btn_plain {
    background: transparent;
    border: 1px solid #132632;
    color: #132632;
  }
  .detail_t_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #595959;
    .detail_t {
      display: flex;
      .detail_label {
        color: #132632;
        font-size: 12px;
        margin-bottom: 12px;
      }
      .detail_value {
        color: #132632;
        font-size: 20px;
        font-weight: 700;
      }
      .detail_status {
        border-radius: 25px;
        background: #3FBF72;
        font-size: 12px;
        color: #000000;
        padding: 1px 18px;
      }
    }
    .detail_t2 {
      color: #38454B;
      font-size: 14px;
      margin-top: 24px;
      display: flex;
      margin-bottom: 32px;
      .t2_status {
        color: #43cf7c;
      }
    }
  }
  .btn_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 32px;
    .el-button + .el-button {
      margin-left: 24px;
    }
    .el-dropdown {
      margin: 0 24px;
    }
    .btn_download, .btn_plain, .btn_right {
      border-radius: 8px;
      height: 42px;
      font-size: 16px;
    }
    .btn_download {
      background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
      color: #F7F8FA;
    }
    .btn_right {
      width: 112px;
      background: linear-gradient(90deg, #FF5733 0%, #FAAC5F 100%);
      color: #FFFFFF;
      border: none;
    }
    &.is_fixed {
      position: fixed;
      background: #FFFFFF;
      z-index: 101;
      top: 0;
      padding: 24px 0;
      border-bottom: 1px solid #ededed;
    }
  }
  .placecss {
    height: 74px;
  }
  .line_box {
    border-radius: 8px;
    background: #F7F8FA;
    padding: 24px;
    border: 1px solid #FFFFFF;
    display: flex;
    align-items: center;
    margin-top: 36px;
    .line_t {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 12px 8px 8px;
      border-bottom: 1px solid #EDEDED;
      font-size: 12px;
      .line_t_download {
        background: linear-gradient(90deg, #DE705F 0%, #E68C93 100%);
        color: #fff;
        cursor: pointer;
        border-radius: 24px;
        width: 64px;
        height: 22px;
        text-align: center;
        line-height: 22px;
        img {
          margin-left: 4px;
          vertical-align: middle;
        }
      }
    }
    .line_l {
      flex-shrink: 0;
      width: 219px;
      border-radius: 4px;
      background: #FFFFFF;
      .line_l_main {
        margin: 8px;
        border: 1px solid #343f5c;
        .el-image {
          width: 100%;
          height: 196px;
          vertical-align: middle;
        }
      }
      .line_l_thumb {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        margin-bottom: 8px;
        .line_thumb {
          width: 40px;
          height: 40px;
          border: 1px solid #343f5c;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
            object-fit: contain;
          }
        }
      }
    }
    .el-icon-d-arrow-right {
      margin: 0 8px;
      font-size: 20px;
    }
    .line_r {
      flex: 1;
      align-self: stretch;
      border-radius: 4px;
      background: #FFFFFF;
      .line_img {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin: 8px;
        .line_img_item {
          width: 203px;
          // height: 229px;
          position: relative;
          // margin-bottom: 24px;
          .el-checkbox {
            position: absolute;
            top: 16px;
            left: 16px;
            z-index: 100;
          }
          .line_img_mask {
            position: absolute;
            z-index: 99;
            width: 100%;
            height: 100%;
            background: rgba(3, 3, 3, 0.6);
            display: none;
            flex-direction: column;
            // align-items: center;
            // justify-content: center;
            // gap: 16px;
            .line_img_prev {
              flex: 1;
              color: #FFFFFF;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 22px;
              cursor: pointer;
            }
            .line_img_btn {
              // border-radius: 24px;
              background: #27292D;
              color: #FFFFFF;
              font-size: 14px;
              // width: 84px;
              height: 44px;
              text-align: center;
              line-height: 44px;
              cursor: pointer;
              img {
                vertical-align: middle;
              }
            }
          }
          .line_img_main {
            width: 203px;
            height: 229px;
            
            object-fit: contain;
          }
          &:hover .line_img_mask {
            display: flex;
          }
        }
      }
    }
    .line_title {
      text-align: center;
      margin-top: 8px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 4;
    }
  }
  .fixed_bottom {
    position: fixed;
    bottom: 0;
    z-index: 100;
    background: #fff;
    .selected_num {
      line-height: 64px;
      color: #737373;
      font-size: 14px;
    }
    &.imageless {
      padding: 0 16px;
      right: 24px;
      box-sizing: content-box;
    }
  }
}
</style>